

exports.__esModule = true;

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Route.extend('$xoApplyPPCRoute', {
    path: 'applyPPC',
    directive: _directive2['default'],
    loginRequired: true,
    children: []
});


_squid.$Route;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-credit-components/src/apply-ppc/route.js
 ** module id = 243
 ** module chunks = 1
 **/